import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, CadastroConsulta } from './types';

export const INITIAL_STATE: CadastroConsulta = {
	status: 0,
	data: null,
	dadosAtendimento: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): CadastroConsulta {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRO_CONSULTA_REQUEST: {
				draft.dadosAtendimento = action.payload;
				break;
			}
			case Types.CADASTRO_CONSULTA_SUCCESS: {
				draft.status = action.payload.response.status;
				draft.data = action.payload.request;
				break;
			}
			case Types.CADASTRO_CONSULTA_FAILURE: {
				draft.status = 0;
				draft.data = action.payload;
				break;
			}
			case Types.CADASTRO_CONSULTA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
